import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { BannerService } from '@app/core/services/banner.service';
import { SHARED_MODULES } from '@app/shared';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { loadBanners, updateStorageBannersViewed } from '../../banner';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-list-banners',
  imports: [SHARED_MODULES],
  templateUrl: './list-banners.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListBannersComponent implements OnInit {
  protected banners$: Observable<any[]>;
  protected loading = signal(false);
  private readonly store = inject<Store<AppState>>(Store);
  private readonly destroy = inject(DestroyRef);
  private readonly bannersService = inject(BannerService);
  private readonly _localStorageService = inject(LocalStorageService);

  public ngOnInit() {
    this.loading.set(true);
    this.banners$ = loadBanners(this.store, this.bannersService, this.destroy).pipe(
      tap(({ userId, banners }) => updateStorageBannersViewed(this._localStorageService, userId, banners)),
      map(({ banners }) => banners),
      tap(() => this.loading.set(false)),
    );
  }
}
